import * as React from "react"
import { createFileRoute } from "@tanstack/react-router"

import { MeterSizeRateType } from "@/types/meter"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from "@/components/ui/credenza"
import {
  DialogClose,
  DialogContent,
  DialogFooter,
} from "@/components/ui/dialog"
import MeterSizeRateForm from "@/components/forms/meter-size-rate-form"

export const Route = createFileRoute(
  "/_home/meter-connection-settings/meter-size-rates/edit",
)({
  component: EditMeterSizeRatesPage,
})

export default function EditMeterSizeRatesPage({
  meterSizeRatesData,
  setShowEditMeterSizeRatesModal,
}: {
  meterSizeRatesData: MeterSizeRateType
  setShowEditMeterSizeRatesModal: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <main>
      <CredenzaContent className="flex w-full max-w-[850px] justify-center">
        <CredenzaBody className="w-full">
          <MeterSizeRateForm
            editData={meterSizeRatesData}
            setShowModal={setShowEditMeterSizeRatesModal}
          />
        </CredenzaBody>
      </CredenzaContent>
    </main>
  )
}
